/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MyFxBookDailyGainsGroupedByAccountDtoSearchResponse } from '../../models/my-fx-book-daily-gains-grouped-by-account-dto-search-response';

export interface SearchMyFxBookDailyGains$Params {
  StartDate?: string;
  EndDate?: string;
  AccountIds?: Array<number>;
  Top?: number;
  Skip?: number;
  SortBy?: string;
  SortDescending?: boolean;
}

export function searchMyFxBookDailyGains(http: HttpClient, rootUrl: string, params?: SearchMyFxBookDailyGains$Params, context?: HttpContext): Observable<StrictHttpResponse<MyFxBookDailyGainsGroupedByAccountDtoSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchMyFxBookDailyGains.PATH, 'get');
  if (params) {
    rb.query('StartDate', params.StartDate, {});
    rb.query('EndDate', params.EndDate, {});
    rb.query('AccountIds', params.AccountIds, {});
    rb.query('Top', params.Top, {});
    rb.query('Skip', params.Skip, {});
    rb.query('SortBy', params.SortBy, {});
    rb.query('SortDescending', params.SortDescending, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MyFxBookDailyGainsGroupedByAccountDtoSearchResponse>;
    })
  );
}

searchMyFxBookDailyGains.PATH = '/api/my-fx-book/daily-gains';
